import React, { useState } from "react";
import useReviewStore from "../../../Stores/useReviewStore";
import styles from "./ReviewForm.module.css";
import Spinner from "../../Shared/Spinner/Spinner";
import Modal from "../../Shared/Modal/Modal";
function ReviewForm() {
  const { createReview, createReviewErrors, createUnprocessableErrors, loadingCreateReview,resetErrors } =
    useReviewStore();

  const [reviewToSubmit, setReviewToSubmit] = useState({
    Name: "",
    Rating: "",
    ReviewDate: new Date().toISOString().split("T")[0],
    ReviewText: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReviewToSubmit((prev) => ({ ...prev, [name]: value }));
  };

  const normalizeReviewPayload = (form) => ({
    Name: (form.Name || "").trim(),
    ReviewText: (form.ReviewText || "").trim(),
    Rating: form.Rating === "" ? null : Number(form.Rating),
    ReviewDate: form.ReviewDate ? form.ReviewDate : null,
  });

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const submitReview = async (e) => {
    e.preventDefault();
  const response = await createReview(normalizeReviewPayload(reviewToSubmit));

    if (response && response.ok) {
      // Reset form on successful submission
      setReviewToSubmit({
        Name: "",
        Rating: "",
        ReviewDate: new Date().toISOString().split("T")[0],
        ReviewText: "",
      });
      resetErrors();
      setModalMessage("Thank you for leaving a review!");
      setShowModal(true);
      
    }
    else {
      setModalMessage("There was an error submitting your review. Please check the form for errors and try again.");
      setShowModal(true);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setModalMessage("");
  }

  const CheckFieldForUnprocessable = (field) => {
    return (
      createUnprocessableErrors &&
      createUnprocessableErrors.some((e) => e.Property === field)
    );
  };

  const GetUnprocessableErrorMessage = (field) => {
    const error = createUnprocessableErrors.find((e) => e.Property === field);
    return error ? error.Error : "";
  };

  return (
    <div className={styles.ReviewSubmissionContainer}>
      {loadingCreateReview && <Spinner />}
         <Modal
        isOpen={showModal}
        onClose={handleModalClose}
        title={modalMessage}
        size="md"
        keepMounted={true}
      ></Modal>
      {createReviewErrors && createReviewErrors.length > 0 && (
        <div className={styles.ErrorContainer}>
          <h3>Errors:</h3>
          <ul>
            {createReviewErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}
      <h2 className={styles.Title}>Submit your review</h2>
      <form className={styles.ReviewForm}>
        <div
          className={`${styles.FormGroup} ${CheckFieldForUnprocessable("Name") ? styles.ErrorField : ""}`}
        >
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="Name"
            required
            value={reviewToSubmit.Name}
            onChange={handleChange}
          />
          {CheckFieldForUnprocessable("Name") && (
            <span className={styles.ErrorMessage}>
              {GetUnprocessableErrorMessage("Name")}
            </span>
          )}
        </div>
        <div
          className={`${styles.FormGroup} ${styles.RatingGroup} ${CheckFieldForUnprocessable("Rating") ? styles.ErrorField : ""}`}
        >
          <label htmlFor="Rating">Rating (optional):</label>
          <input
            type="number"
            id="Rating"
            name="Rating"
            min="1"
            max="5"
            value={reviewToSubmit.Rating}
            onChange={handleChange}
          />
          <span className={styles.watermark}>/5</span>
          {CheckFieldForUnprocessable("Rating") && (
            <span className={styles.ErrorMessage}>
              {GetUnprocessableErrorMessage("Rating")}
            </span>
          )}
        </div>
        <div
          className={`${styles.FormGroup} ${CheckFieldForUnprocessable("ReviewDate") ? styles.ErrorField : ""}`}
        >
          <label htmlFor="ReviewDate">Review Date:</label>
          <input
            type="date"
            id="ReviewDate"
            name="ReviewDate"
            value={reviewToSubmit.ReviewDate}
            onChange={handleChange}
          />
          {CheckFieldForUnprocessable("ReviewDate") && (
            <span className={styles.ErrorMessage}>
              {GetUnprocessableErrorMessage("ReviewDate")}
            </span>
          )}
        </div>
        <div
          className={`${styles.FormGroup} ${CheckFieldForUnprocessable("ReviewText") ? styles.ErrorField : ""}`}
        >
          <label htmlFor="ReviewText">Review:</label>
          <textarea
            id="ReviewText"
            name="ReviewText"
            rows={10}
            required
            value={reviewToSubmit.ReviewText}
            onChange={handleChange}
          ></textarea>
          {CheckFieldForUnprocessable("ReviewText") && (
            <span className={styles.ErrorMessage}>
              {GetUnprocessableErrorMessage("ReviewText")}
            </span>
          )}
        </div>
        <button
          className={styles.SubmitButton}
          type="button"
          onClick={submitReview}
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default ReviewForm;
